import jQuery from 'jquery';
import $ from 'jquery';

window.jQuery = jQuery;
window.$ = $;
